// extracted by mini-css-extract-plugin
export default {"Overall":"Board_Overall__Hwciq","BoardContent":"Board_BoardContent__vKu43"};